import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, X, Eye, Ban } from "lucide-react";
import { toast } from "sonner";

export function NotificationsBanner() {
  const [unreadTotal, setUnreadTotal] = useState(0);
  useEffect(() => { api.get("/notifications/summary").then((r) => setUnreadTotal(r.data.unread)).catch(() => {}); }, []);
  const [items, setItems] = useState([]); const navigate = useNavigate();
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data.filter((n) => !n.read))).catch(() => {}); }, []);
  if (items.length === 0) return null;
  const dismiss = async (id) => { await api.post(`/notifications/${id}/read`); setItems((p) => p.filter((n) => n.id !== id)); };
  const decide = async (n, decision) => {
    try { await api.post(`/competitor-suggestions/${n.meta.suggestion_id}/decide`, { decision }); toast.success(decision === "accept" ? "Concurrent surveillé" : "Ne sera plus proposé"); dismiss(n.id); }
    catch (e) { toast.error(e.response?.data?.detail || "Action impossible"); }
  };
  return (
    <div className="mb-5 space-y-2" data-testid="notifications-banner">
      {items.slice(0, 2).map((n) => (
        <div key={n.id} className="flex items-start gap-3 rounded-xl border border-indigo-200 bg-indigo-50/60 px-4 py-3 text-sm" data-testid={`notification-${n.id}`}>
          <Bell className="w-4 h-4 text-indigo-600 mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <button onClick={async () => { if (n.link) { await dismiss(n.id); navigate(n.link); } }} className="text-left w-full" data-testid={`notification-open-${n.id}`}><div className="font-medium text-indigo-900">{n.title}</div>
            <div className="text-indigo-800/80 text-xs mt-0.5">{n.message}{n.link ? " · ouvrir" : ""}</div></button>
            {n.type === "competitor_new" && n.meta?.suggestion_id && (
              <div className="flex gap-2 mt-2">
                <button onClick={() => decide(n, "accept")} className="text-xs rounded-lg bg-blue-600 text-white px-2.5 py-1 inline-flex items-center gap-1" data-testid={`notification-watch-${n.id}`}><Eye className="w-3 h-3" /> Surveiller ce concurrent</button>
                <button onClick={() => decide(n, "not_competitor")} className="text-xs rounded-lg bg-white border border-slate-200 text-slate-600 px-2.5 py-1 inline-flex items-center gap-1" data-testid={`notification-not-${n.id}`}><Ban className="w-3 h-3" /> Pas un concurrent</button>
              </div>
            )}
          </div>
          <button onClick={() => dismiss(n.id)} className="text-indigo-400 hover:text-indigo-700" data-testid={`notification-dismiss-${n.id}`}><X className="w-4 h-4" /></button>
        </div>
      ))}
      {items.length > 2 && <button onClick={() => navigate("/app/notifications")} className="text-xs text-indigo-700 underline" data-testid="notifications-see-all">Voir toutes les notifications{unreadTotal ? ` (${unreadTotal} non lues)` : ""}</button>}
    </div>
  );
}
